import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-field-reporting',
    templateUrl: './field-reporting.component.html',
    styleUrls: ['./field-reporting.component.scss'],
    standalone: false
})
export class FieldReportingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
